import React, {Component} from 'react';

import './Login.css';

export default class Login extends Component {
  state = {
    email: '',
    password: '',
    error: ''
  };

  updateField = field => {
    return e => {
      this.setState({
        [field]: e.target.value
      })
    }
  };

  handleLoginClick = () => {
    this.props.firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
        .catch(error => {
          console.log(error);

          this.setState({
            error: 'email or password incorrect',
            email: '',
            password: ''
          })
        })
  };

  render() {
    let errorEl;

    if (this.state.error) {
      errorEl = <div className="error">{this.state.error}</div>
    }

    return (
        <div className="login">
          <label>Email:<br />
            <input type="text" value={this.state.email} onChange={this.updateField('email')}/>
          </label><br />
          <label>Password:<br />
            <input type="password" value={this.state.password} onChange={this.updateField('password')}/>
          </label><br />
          <button onClick={this.handleLoginClick}>Login</button>
          {errorEl}
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Login/Login.js